export default class FileExplorerModelEvent {
    constructor(type) {
        this.type = type;
    }
}

FileExplorerModelEvent.TREE_CHANGED = "FileExplorerModelEvent.TREE_CHANGED";